import { Cell, Grid, HeadingSection, Text } from 'bold-ui'
import { PeriodoAusencia } from 'graphql/types.generated'
import { PeriodoAusenciaTable } from 'view/cidadao/create/components/PeriodoAusenciaTable'

interface PeriodoAusenciaSaudeIndigenaSectionProps {
  periodoAusenciaList?: ReadonlyArray<PeriodoAusencia>
}

export const PeriodoAusenciaSaudeIndigenaSection = (props: PeriodoAusenciaSaudeIndigenaSectionProps) => {
  const { periodoAusenciaList } = props
  return (
    <HeadingSection level={2} title='Período de ausência'>
      <Grid>
        <Cell size={12}>
          <Text fontWeight='bold'>Histórico das datas</Text>
        </Cell>
        <Cell size={5}>
          <PeriodoAusenciaTable periodoAusenciaList={periodoAusenciaList} unbounded />
        </Cell>
        <Cell size={7} />
      </Grid>
    </HeadingSection>
  )
}
